import type { FaireProductEntity } from "../../entity_types/product";

export const p_qu3j9azyau: FaireProductEntity = {
  token: "p_qu3j9azyau",
  type: "product",
  name: "Blue Bear Training Chopsticks Plastic With Adjustable Silicone Finger Rings (6/24/144)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/57391a703186d359315e68e6d2496a3defbe8287465a4cff121af9081910c578.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/725806b991173fa380f2c4dbada576a01b91eb3768173a1b147a416d59ccf613.jpeg",
    "https://cdn.faire.com/fastly/ac1789c3c09079f0a3e8ba391870f4e9b562c8ba6e8b94f7648324b427823be3.jpeg",
    "https://cdn.faire.com/fastly/93742a6ff286ddc972e3d9754db9460e537e16b32f8bdb1cf23affbc7842cd8f.jpeg",
    "https://cdn.faire.com/fastly/212c200eae73cf2c19eab11d15870bfeed0b85c63cecf6521e4e22ec80f49740.jpeg"
  ],
  priceDollars: 1.75,
  description: "Size: 7.4\"L x 1.5\"W\n\nInner Pack : 6pc Case Pack : 144pc\n\nMaterial: ABS Plastic/Silicone\n\nOrigin: China\n\n\n",
  tags: [],
  msrpDollars: 3.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:51.471Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
